var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "box view-nav-bar" }, [
        _c("div", { staticClass: "d-flex align-items-center w-100" }, [
          _c(
            "div",
            { staticClass: "flex-grow-1" },
            [
              _c(
                "router-link",
                { staticClass: "mr-3", attrs: { to: "/admissions/movie-tag" } },
                [
                  _c("icon", { attrs: { name: "chevron-left" } }),
                  _vm._v(" Back\n                "),
                ],
                1
              ),
              _vm._v(" "),
              _c("strong", [_vm._v("Per movie tag")]),
              _vm._v(" "),
              _c("span", { staticClass: "text-muted ml-2" }, [
                _vm._v("— cinema year "),
                _c("strong", [_vm._v(_vm._s(_vm.year))]),
                _vm._v(", Brightfish preshow admissions (sales house BF)"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-inline" },
            [
              parseInt(_vm.year, 10) > _vm.firstTagYear
                ? _c(
                    "router-link",
                    {
                      staticClass: "btn btn-sm btn-outline-secondary mr-2",
                      attrs: {
                        to:
                          "/admissions/movie-tag/" +
                          (parseInt(_vm.year, 10) - 1),
                      },
                    },
                    [
                      _c("icon", { attrs: { name: "chevron-left" } }),
                      _vm._v(
                        " " +
                          _vm._s(parseInt(_vm.year, 10) - 1) +
                          "\n                "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn-sm btn-outline-secondary",
                  attrs: {
                    to: "/admissions/movie-tag/" + (parseInt(_vm.year, 10) + 1),
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(parseInt(_vm.year, 10) + 1) +
                      " "
                  ),
                  _c("icon", { attrs: { name: "chevron-right" } }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [_vm._v("Loading…")]
            ),
          ])
        : parseInt(_vm.year, 10) < _vm.firstTagYear
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [
                _vm._v(
                  "Movie tags are only available from cinema year " +
                    _vm._s(_vm.firstTagYear) +
                    "."
                ),
              ]
            ),
          ])
        : !_vm.totals.weeks
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [_vm._v("No Brightfish admissions in " + _vm._s(_vm.year) + ".")]
            ),
          ])
        : [
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "box-content" },
                [
                  _c("heading", {
                    attrs: {
                      upper: "Per tag",
                      lower:
                        _vm.rows.length +
                        " tags, " +
                        _vm.formatInt(_vm.totals.admissions) +
                        " admissions over " +
                        _vm.totals.weeks +
                        " weeks",
                      border: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.rows, function (tag) {
                        return _c("tr", { key: tag.movie_tag || "none" }, [
                          _c("td", [
                            _c(
                              "a",
                              {
                                class: { "text-muted": !tag.movie_tag },
                                attrs: {
                                  href: "#tag-" + _vm.slug(tag.movie_tag),
                                },
                              },
                              [_vm._v(_vm._s(_vm.tagLabel(tag.movie_tag)))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(tag.movies)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(tag.weeks)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.formatInt(tag.admissions))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(tag.pct !== null ? tag.pct + "%" : "—")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                tag.movies
                                  ? _vm.formatInt(tag.admissions / tag.movies)
                                  : "—"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "progress",
                                staticStyle: { height: "8px" },
                                attrs: {
                                  title: (tag.pct !== null ? tag.pct : 0) + "%",
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "progress-bar",
                                  style: { width: (tag.pct || 0) + "%" },
                                  attrs: { role: "progressbar" },
                                }),
                              ]
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [_vm._v(_vm._s(_vm.totals.movies))]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [_vm._v(_vm._s(_vm.totals.weeks))]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.formatInt(_vm.totals.admissions))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.totals.movies
                                  ? _vm.formatInt(
                                      _vm.totals.admissions / _vm.totals.movies
                                    )
                                  : "—"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
                    _vm._v("\n                    Only rows with "),
                    _c("code", [_vm._v("saleshouse = BF")]),
                    _vm._v(
                      " of cinema year " +
                        _vm._s(_vm.year) +
                        " count.\n                    "
                    ),
                    _c("em", [_vm._v(_vm._s(_vm.tagLabel(null)))]),
                    _vm._v(
                      " collects titles without a Movix id, without a history row or without a tag;\n                    their admissions count, but only identified movies are listed below.\n                    Same data as JSON: "
                    ),
                    _c("code", [
                      _vm._v(
                        "GET /api/v1/admissions/movie-tag/" + _vm._s(_vm.year)
                      ),
                    ]),
                    _vm._v(".\n                "),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.rows, function (tag) {
              return _c(
                "div",
                {
                  key: "top-" + (tag.movie_tag || "none"),
                  staticClass: "box",
                  attrs: { id: "tag-" + _vm.slug(tag.movie_tag) },
                },
                [
                  _c(
                    "div",
                    { staticClass: "box-content" },
                    [
                      _c("heading", {
                        attrs: {
                          upper: _vm.tagLabel(tag.movie_tag),
                          lower:
                            "Top " +
                            tag.top.length +
                            " of " +
                            tag.movies +
                            " movies, " +
                            _vm.formatInt(tag.admissions) +
                            " admissions (" +
                            (tag.pct !== null ? tag.pct : 0) +
                            "% of " +
                            _vm.year +
                            ")",
                          border: "",
                        },
                      }),
                      _vm._v(" "),
                      tag.top.length
                        ? _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                            _vm._m(3, true),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(tag.top, function (movie) {
                                return _c("tr", { key: movie.movix_id }, [
                                  _c("td", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(movie.rank)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/history/" + movie.movix_id,
                                          },
                                        },
                                        [_vm._v(_vm._s(movie.movix_id))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(movie.title || "—")),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(movie.weeks)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      _vm._s(_vm.formatInt(movie.admissions))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        movie.pct !== null
                                          ? movie.pct + "%"
                                          : "—"
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        movie.pct_year !== null
                                          ? movie.pct_year + "%"
                                          : "—"
                                      )
                                    ),
                                  ]),
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("tfoot", [
                              _c("tr", [
                                _c("td", { attrs: { colspan: "4" } }, [
                                  _c("strong", [
                                    _vm._v("Top " + _vm._s(tag.top.length)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatInt(_vm.topAdmissions(tag))
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.pct(
                                          _vm.topAdmissions(tag),
                                          tag.admissions
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.pct(
                                          _vm.topAdmissions(tag),
                                          _vm.totals.admissions
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ])
                        : _c("p", { staticClass: "text-muted small mb-0" }, [
                            _vm._v("No identified movies."),
                          ]),
                    ],
                    1
                  ),
                ]
              )
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Movie tag")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Movies"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Preshow (BF)")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("% of year"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Avg / movie"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-200" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Total")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "text-right" }, [
      _c("strong", [_vm._v("100%")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-50" }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-80" }, [_vm._v("Movix")]),
        _vm._v(" "),
        _c("th", [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Preshow (BF)")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("% of tag"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("% of year"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }